// extracted by mini-css-extract-plugin
export default {"profileWrapper":"ProfileUpdate_profileWrapper__tFSMs","error":"ProfileUpdate_error__olanh","input":"ProfileUpdate_input__CUqH8","inputWrapper":"ProfileUpdate_inputWrapper__hM51m"};